// eslint-disable-next-line no-redeclare
/* global PubSub:true */
import { Component } from 'react'

import { SHOW_GIFT_RETURN_MODAL } from 'shared/constants'
import { Modal, ModalBody } from 'components/modal'
import { contactUsPath } from 'lib/urls'
import GiftReturnModalContent from './components/GiftReturnModalContent/GiftReturnModalContent'

export default class GiftReturnModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false,
      reservationToken: null,
      storeName: null,
      orderNum: null,
    }
  }

  componentDidMount() {
    PubSub.subscribe(
      SHOW_GIFT_RETURN_MODAL,
      ({
        reservationToken,
        storeName,
        orderNum,
        regItem,
        giftGiverName,
        giftGiverEmail,
        daysSincePurchase,
      }) => {
        this.setState({
          show: true,
          reservationToken,
          storeName,
          orderNum,
          regItem,
          giftGiverName,
          giftGiverEmail,
          daysSincePurchase,
        })
      }
    )
  }

  onSuccess = () => {
    PubSub.publish('flashMessage', {
      variant: 'success',
      message:
        "We've received your return request! A Happiness Hero will get back to you shortly!",
    })
    this.hideModal()
  }

  onFailure = () => {
    PubSub.publish('flashMessage', {
      variant: 'error',
      message: `We were unable to process your request. You can try again or <a href="${contactUsPath}">contact a Happiness Hero directly</a>!`,
    })
    this.hideModal()
  }

  hideModal = () => {
    this.setState({ show: false })
  }

  render() {
    const {
      show,
      regItem,
      reservationToken,
      storeName,
      orderNum,
      daysSincePurchase,
      giftGiverEmail,
      giftGiverName,
    } = this.state

    if (!show) return null
    return (
      <Modal
        show={show}
        size="large"
        title="Returning a gift? Let us help!"
        onHide={this.hideModal}
      >
        <ModalBody>
          <GiftReturnModalContent
            daysSincePurchase={daysSincePurchase}
            giftGiverEmail={giftGiverEmail}
            giftGiverName={giftGiverName}
            orderNum={orderNum}
            regItem={regItem}
            reservationToken={reservationToken}
            storeName={storeName}
            onFailure={this.onFailure}
            onSuccess={this.onSuccess}
          />
        </ModalBody>
      </Modal>
    )
  }
}
